module.exports = __webpack_public_path__ + "static/media/my_marker.a449106c.png";